const BASE_URL = import.meta.env.VITE_API_URL ?? '';

function buildHeaders() {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  // function buildHeaders(state?: RootState) {
  // attach userId if present
  // (admin endpoints don't use userId but this helper is shared pattern)
  // caller can pass state if needed
  return headers;
}

export type AdminStat = {
  role: string;
  default_thinking: boolean;
  input_tokens: number;
  input_count: number;
  output_tokens: number;
  output_count: number;
};

export async function fetchAdminStats(username: string): Promise<AdminStat[]> {
  if (!username) throw new Error("Admin stats failed: No admin found.");
  const url = `${BASE_URL}/a/s?username=${username}`;
  const res = await fetch(url, { method: 'GET', headers: buildHeaders() });
  if (!res.ok) throw new Error(`Admin stats failed: ${res.status}`);
  return res.json();
}

export type AdminRow = {
  role: 'ai' | 'user' | 'system';
  display_name?: string;
  content: string | null;
  sql_query?: string | null;
  default_thinking: boolean;
  default_context: boolean;
  input_token: number;
  output_token: number;
};

export async function fetchAdminRows(username: string, {offset = 0, limit = 50, sortBy = 'createdAt', order = 'desc'}: {
  offset?: number;
  limit?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
}): Promise<AdminRow[]> {
  if (!username) throw new Error("Admin stats failed: No admin found.");
  const q = new URLSearchParams({
    username: String(username),
    offset: String(offset),
    limit: String(limit),
    sortBy,
    order,
  });
  const url = `${BASE_URL}/a?${q.toString()}`;
  const res = await fetch(url, { method: 'GET', headers: buildHeaders() });
  if (!res.ok) throw new Error(`Admin rows failed: ${res.status}`);
  return res.json();
}
